import { CSVHeaderConfig } from 'src/pages/SharedPageCustomHooks/UseDownloadCSV/types';

export const serviceRequestCsvHeadersConfigObj: CSVHeaderConfig[] = [
  { label: 'Property Name', key: 'propertyName' },
  {
    label:
      localStorage.getItem('theme') === 'Shape'
        ? 'Unit Number'
        : 'Suite Number',
    key: 'suiteNumber',
  },
  { label: 'Suite Civic Address', key: 'suiteCivicAddress' },
  { label: 'Ticket Number', key: 'ticketNumber' },
  { label: 'Submitted Date', key: 'createdDateSt' },
  { label: 'Last Updated', key: 'lastUpdatedst' },
  { label: 'Status', key: 'status' },
  { label: 'Subject', key: 'subject' },
  { label: 'Description', key: 'description' },
  { label: 'Room', key: 'area.name' },
  { label: 'Asset', key: 'itemName' },
  { label: 'Issue Type', key: 'serviceType' },
  { label: 'Tags', key: 'tagsst' },
  { label: 'Walkthrough Name', key: 'walkthroughName' },
  { label: 'Primary HomeOwner Name', key: 'homeOwnerName' },
  { label: 'Primary HomeOwner Email', key: 'homeOwnerEmail' },
  { label: 'Primary HomeOwner Phone Number', key: 'homeOwnerContactInfo' },
  { label: 'Reporter Name', key: 'reporterName' },
  { label: 'Assigned To', key: 'serviceProvider' },
  { label: 'Appointment', key: 'scheduledAt' },
  { label: 'Property Developer', key: 'propertyManager' },
  { label: 'URL', key: 'url' },
  { label: 'Attachments', key: 'attachment' },
  { label: 'Approved Date', key: 'approvedDatest' },
  { label: 'Under Review Date', key: 'underReviewDatest' },
  { label: 'Assigned Date', key: 'assignedDatest' },
  { label: 'In Progress Date', key: 'inProgressDatest' },
  { label: 'En Route Date', key: 'enRouteDatest' },
  { label: 'On Hold Date', key: 'onHoldDatest' },
  { label: 'Declined Date', key: 'declinedDatest' },
  { label: 'Scheduled Date', key: 'scheduleDatest' },
  { label: 'Resolved Date', key: 'resolvedDatest' },
  { label: 'Closed Date', key: 'closedDatest' },
  { label: 'One Year Warranty Date', key: 'oneYearWarrantyDatest' },
];
